// Video materi per modul belajar, diputar sebelum modul dimulai (lihat bukaModul di mesin.js).
// Sumber video: promo/materi/<kode>/ (rancangan di docs/rancangan-video-materi.md). Versi 1080p
// diarsipkan di promo/video/, versi web 720p ada di public/video/materi/<kode>-{tegak,lanskap}.{mp4,jpg}.
// Satu modul boleh punya beberapa video; diputar berurutan.

export const VIDEO_MODUL = {
  // Matematika · Bilangan
  'pecahan-senilai': [{ kode: 'm-b02-pecahan-senilai', judul: 'Pecahan senilai' }],
  'urutan-pecahan': [{ kode: 'm-b05-samakan-penyebut', judul: 'Penyebut beda? Samakan dulu' }],
  'desimal-persen': [
    { kode: 'm-b07-persen', judul: 'Persen = per seratus' },
    { kode: 'm-b08-diskon', judul: 'Menghitung harga diskon' },
  ],
  'tambah-kurang-pecahan': [{ kode: 'm-b10-jumlah-pecahan', judul: 'Menjumlah pecahan berpenyebut beda' }],
  'kali-bagi-pecahan': [{ kode: 'm-b13-bagi-pecahan', judul: 'Membagi pecahan' }],
  'kpk-fpb': [{ kode: 'm-b14-kpk', judul: 'KPK: kapan bertemu lagi?' }],
  'operasi-hitung': [{ kode: 'm-b17-urutan-operasi', judul: 'Urutan operasi hitung' }],
  // Matematika · Geometri & Pengukuran
  'keliling-luas': [{ kode: 'm-g02-luas-segitiga', judul: 'Luas segitiga = setengah persegi panjang' }],
  volume: [{ kode: 'm-g05-volume', judul: 'Volume: lapisan demi lapisan' }],
  'bangun-ruang': [{ kode: 'm-g07-dadu', judul: 'Rahasia dadu: berhadapan = 7' }],
  'satuan-ukur': [{ kode: 'm-g10-tangga-satuan', judul: 'Tangga satuan' }],
  'waktu-kecepatan': [{ kode: 'm-g13-kecepatan', judul: 'Jarak, kecepatan, waktu' }],
  sudut: [{ kode: 'm-g16-sudut-segitiga', judul: 'Sudut segitiga = 180°' }],
  // Matematika · Data
  'membaca-data': [{ kode: 'm-d01-turus-modus', judul: 'Turus, frekuensi & modus' }],
  // Bahasa Indonesia
  'bi-gagasan-pokok': [{ kode: 'i-01-gagasan-pokok', judul: 'Gagasan pokok: uji payung' }],
  'bi-informasi-tersurat': [{ kode: 'i-03-informasi-tersurat', judul: 'Informasi tersurat: cari kata kunci' }],
  'bi-sebab-akibat': [{ kode: 'i-06-sebab-akibat', judul: 'Sebab dan akibat' }],
  'bi-tokoh-watak': [{ kode: 'f-01-watak-tokoh', judul: 'Watak tokoh dari buktinya' }],
  'bi-latar-alur': [{ kode: 'f-02-gunung-alur', judul: 'Alur cerita: gunung alur' }],
  'bi-amanat-tema': [{ kode: 'f-05-tema-amanat', judul: 'Tema atau amanat?' }],
};

/** Daftar video sebuah modul untuk pemutar: [{ judul, tegak, lanskap }] (tanpa ekstensi). */
export const videoModul = id => (VIDEO_MODUL[id] || []).map(v => ({
  kode: v.kode, judul: v.judul,
  tegak: `/video/materi/${v.kode}-tegak`, lanskap: `/video/materi/${v.kode}-lanskap`,
}));
